import React, {PureComponent} from "react";
import {SceneryType} from "../../store/settings/SceneryType";
import {cssHelper} from "../../shared/utils/cssHelper";
import styles from "./level-map.module.css";
import {DecalType, ILevelMapDecal, IPoint} from "../../store/game/types";
import {TweenLite, Elastic, Animation} from "gsap";
import {random, randomInt} from "../../shared/utils/random";
import {spread} from "../../shared/utils/spread";
import playSound from "../../shared/sounds/playSound";

interface DecalProps extends ILevelMapDecal {
    scenery: SceneryType;
}

export class Decal extends PureComponent<DecalProps> {
    private hostElement: HTMLDivElement | null = null;
    private activeTween?: Animation;

    render() {
        const size = DecalType[this.props.type || 0].toLowerCase();
        const className = cssHelper()
            .add(styles.decal)
            .add(styles[`${size}_decal`])
            .add(`${this.props.scenery}_${size}_decal_${this.props.index}`);

        const position = this.getDecalPosition(this.props.coords);

        return (
            <div ref={element => this.hostElement = element} className={className.toString()} style={position} onClick={() => this.onClick()} data-animated={0.5}/>
        );
    }

    componentWillUnmount(): void {
        this.activeTween && this.activeTween.kill();
    }

    private onClick() {
        if (!this.hostElement)
            return;

        playSound("mouth-pop");

        this.activeTween && this.activeTween.kill();
        this.activeTween = TweenLite.fromTo(this.hostElement, 0.33, {
            scale: 1,
            rotation: 1,
        }, {
            scale: spread([0.85, 1.15], 0.1),
            rotation: Math.round(spread([-7, 7], 0.2)),
            ease: Elastic.easeInOut.config(10, 0.3)
        });
    }

    private getDecalPosition(coords: IPoint) {
        return {
            left: `calc(50% + (${coords.x}px))`,
            top: `calc(50% - (${coords.y}px))`,
            transform: `translateX(-50%) translateY(-50%) scaleX(${Math.random() > 0.5 ? 1 : -1}) scale(${random(0.85, 1).toFixed(1)}) rotate(${randomInt(-7, 7)}deg)`
        };
    }
}